import * as common from 'store/modules/common'
import { toast } from 'react-toastify'
import { api } from './api'
import { fromUtcString } from 'utils/dateUtilities'
import { format } from 'utils/stringUtilities'
import { localize } from 'store/modules/localization'

export const actionTypePrefix = 'orderProcessing'

export { api }
export const initialState = { ...common.initialState }
export const actionTypes = { ...common.actionTypes(actionTypePrefix) }
export const actionCreators = {
  ...common.actionCreators(actionTypePrefix, api),

  createBottles: (dto, callback) => (dispatch, getState) => {
    dispatch({ type: common.actionTypes(actionTypePrefix).saving })
    api.createBottles(dto)
      .then(response => {
        dispatch({ type: common.actionTypes(actionTypePrefix).saved, payload: response })
        const notificationText = format(localize(getState().localization, 'ordersProcessing.bottlesStored'), response.createdBottlesCount, response.updatedBottlesCount)
        toast.info(notificationText)
        if (typeof callback === 'function') { callback(response) }
      })
      .catch(error => common.handleError(actionTypePrefix, { getState, dispatch, error, update: { saving: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    default: return common.reducer(state, action, actionTypePrefix, {
      transformPayload: payload => ({
        ...payload,
        dateOfOrder: fromUtcString(payload.dateOfOrder)
    })})
  }
}

